export default {
  first_name: "string",
  last_name: "string",
  user_id: "number"
}
